import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import { Stack, Typography } from "@mui/material";

import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const ChartEmptyState = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1.5}
      sx={{ flex: 1, height: "100%" }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, color: "primary.main" }} />
      <Typography variant="body1" color="text.secondary">
        {t(Resources.Reporting.NoData)}
      </Typography>
    </Stack>
  );
};
